import React from "react";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import NavSubItem from "../Sidebar/NavSubItem";
import IconFutureImaging from "../../Icons/TopCommandPanel/FutureImaging";
import IconPlatesWaitingToBeImaged from "../../Icons/TopCommandPanel/PlatesWaitingToBeImaged";
import IconImagingHistory from "../../Icons/TopCommandPanel/ImagingHistory";

const SchedulingNavSubMenu = () => {
  return (
    <SidebarSubmenu>
      <NavSubItem
        label={"Queued"}
        key="tobeImaged"
        to={"/schedule/queued"}
        icon={<IconPlatesWaitingToBeImaged />}
      />
      <NavSubItem
        label={"Future"}
        key="futureImaging"
        to={"/schedule/future"}
        icon={<IconFutureImaging />}
      />
      <NavSubItem
        label={"History"}
        key="imagingHistory"
        to={"/schedule/history"}
        icon={<IconImagingHistory />}
      />
    </SidebarSubmenu>
  );
};

export default SchedulingNavSubMenu;
